import {
  VisuallyHidden,
  OutlineCircleQuestionIcon,
} from '@frontend/legacy-components';

import HeaderIconButton from 'components/HeaderIconButton/HeaderIconButton';

type HelpModeTriggerProps = {
  className?: string;
  onClick: () => void;
};

const HelpModeTrigger = ({ className, onClick }: HelpModeTriggerProps) => (
  <HeaderIconButton
    color="feature.onInteraction"
    className={className}
    onClick={onClick}
  >
    <OutlineCircleQuestionIcon size={4} />
    <VisuallyHidden>Open Help Mode</VisuallyHidden>
  </HeaderIconButton>
);

export default HelpModeTrigger;
